import gql from 'graphql-tag';

export const CANCEL_SUBSCRIPTION = gql`
  mutation cancelSubscription($userId: String!, $productId: String!) {
    cancelSubscription(userId: $userId, productId: $productId) {
      errors
    }
  }
`;
